/* unplugin-vue-components disabled */import { render } from "./navbar-mobile.vue?vue&type=template&id=6e8ba950&scoped=true"
import script from "./navbar-mobile.vue?vue&type=script&lang=js"
export * from "./navbar-mobile.vue?vue&type=script&lang=js"

import "./navbar-mobile.vue?vue&type=style&index=0&id=6e8ba950&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e8ba950"],['__file',"src/components/navbar/navbar-mobile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e8ba950"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e8ba950', __exports__)) {
    api.reload('6e8ba950', __exports__)
  }
  
  module.hot.accept("./navbar-mobile.vue?vue&type=template&id=6e8ba950&scoped=true", () => {
    api.rerender('6e8ba950', render)
  })

}


export default __exports__